import { copyTextBankActions } from '../../actions/constant';

const { REQUEST_SEARCH_CPT_CODES, SUCCESS_SEARCH_CPT_CODES, FAILURE_SEARCH_CPT_CODES } =
  copyTextBankActions;

const intitialstate: object = {
  response: null,
  loading: false,
  getDescriptions: false,
};

export const getCPTCodeScriptionReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_SEARCH_CPT_CODES: {
      return {
        ...state,
        getDescriptions: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_SEARCH_CPT_CODES:
      return {
        ...state,
        getDescriptions: false,
        response: action.payload,
        loading: false,
      };

    case REQUEST_SEARCH_CPT_CODES:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
